import axios from 'axios';
import { getAccessToken } from '../helpers/auth/token';

// Global axios config
const axiosInstance = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        // Adding dynamic headers
        const token = getAccessToken()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        // Handle successful response
        return response;
    },
    (error) => {
        // Handle errors globally (e.g., unauthorized access)
        // if (error.response && error.response.status > 401) {
        //     console.error("There was an error!", error);
        //     throw error
        // }
        console.error(error.message)
        throw error.response
        // return Promise.reject(error);
    }
);

export default axiosInstance;